/**
 * Modales con la información legal de la página
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2003-2025 Mendikat
 * @license Mendikat
 * @version {see config/app.php}
 */

/**
 * El idioma actual de la página
 */
const lang = document.querySelector('html').getAttribute('lang');

/**
 * La modal de condiciones de uso del sitio web
 */
const useConditions =
    {
        url         : `/${lang}/legal/use-conditions`,
        modal       : document.getElementById('modal-use-conditions'),
        content     : document.querySelector('.use-conditions-content'),
    };

/**
 * La modal de política de provacidad del sitio web
 */
 const privacyPolicy =
    {
        url         : `/${lang}/legal/privacy-policy`,
        modal       : document.getElementById('modal-privacy-policy'),
        content     : document.querySelector('.privacy-policy-content'),
    };

/**
 * La modal de política de cookies del sitio web
 */
const cookiesPolicy =
    {
        url         : `/${lang}/legal/cookies-policy`,
        modal       : document.getElementById('modal-cookies-policy'),
        content     : document.querySelector('.cookies-policy-content'),
    };

/**
 * La modal de acerca del sitio web
 */
const aboutInfo =
    {
        url         : `/${lang}/legal/about`,
        modal       : document.getElementById('modal-about'),
        content     : document.querySelector('.about-content'),
    };

/**
 * La modal de créditos
 */
 const creditsInfo =
 {
     url         : `/${lang}/legal/credits`,
     modal       : document.getElementById('modal-credits'),
     content     : document.querySelector('.credits-content'),
 };

/**
 * Al abrir la modal que muestra las condiciones de uso del sitio web
 *
 */
useConditions.modal.addEventListener('shown.bs.modal', function () {

    fetch(useConditions.url)
        .then(response => response.text())
        .then(html => {
            useConditions.content.innerHTML = html;
        })
        .catch(error => {
            console.error(error);
        });
});

/**
 * Al abrir la modal que muestra la política de privacidad
 *
 */
privacyPolicy.modal.addEventListener('shown.bs.modal', function () {

    fetch(privacyPolicy.url)
        .then(response => response.text())
        .then(html => {
            privacyPolicy.content.innerHTML = html;
        })
        .catch(error => {
            console.error(error);
        });
});

/**
 * Al abrir la modal que muestra la política de cookies
 *
 */
cookiesPolicy.modal.addEventListener('shown.bs.modal', function () {

    fetch(cookiesPolicy.url)
        .then(response => response.text())
        .then(html => {
            cookiesPolicy.content.innerHTML = html;
        })
        .catch(error => {
            console.error(error);
        });
});

/**
 * Al abrir la modal que muestra el contenido acerca del sitio web
 *
 */
aboutInfo.modal.addEventListener('shown.bs.modal', function () {

    fetch(aboutInfo.url)
        .then(response => response.text())
        .then(html => {
            aboutInfo.content.innerHTML = html;
        })
        .catch(error => {
            console.error(error);
        });
});

/**
 * Al abrir la modal que muestra los créditos
 *
 */
creditsInfo.modal.addEventListener('shown.bs.modal', function () {

    fetch(creditsInfo.url)
        .then(response => response.text())
        .then(html => {
            creditsInfo.content.innerHTML = html;
        })
        .catch(error => {
            console.error(error);
        });
});
